import { styled } from '@mui/material/styles'

export const Option = styled('div', {
  name: 'Option',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  paddingTop: '0.1px',
  marginBottom: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
}))
